/* stylelint-disable-next-line plugin/no-unsupported-browser-features */
/* Do not use this */
/* Use this */
.nav-drawer {
  --drawer-bg-color: var(--go-color-lightest);
  --drawer-max-width: 24rem;
  --nav-item-text-color: var(--go-color-darkest);
  --nav-item-bg-color: var(--go-color-lightest);
  --nav-item-hover-bg-color: var(--go-color-neutral-200);
  --nav-item-padding: var(--go-size--1) var(--go-size-0);
  --nav-header-padding: var(--go-size--1) var(--go-size-0);
  --nav-header-border-color: var(--go-color-neutral-200);
  --nav-item-icon-gap: var(--go-size-0);
  --nav-item-current-bar-width: 0.25rem;
  --nav-item-current-bar-color: var(--go-color-primary-500);
  --submenu-parent-link-border-bottom: 0.0625rem solid var(--go-color-neutral-200);
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--layer-important);
  background: var(--drawer-bg-color);
  transform: translateX(-100%);
  transition: transform var(--go-duration-normal) var(--go-timing-function);
}
@media (prefers-reduced-motion: reduce) {
  .nav-drawer {
    transition-duration: 0s;
  }
}
@media (prefers-reduced-motion: reduce) {
  .nav-drawer {
    transition-duration: 0s;
  }
}
@media (min-width: 600px) {
  .nav-drawer {
    width: var(--drawer-max-width);
  }
}
.nav-drawer.right {
  left: auto;
  right: 0;
  transform: translateX(100%);
}
.nav-drawer.open {
  transform: translateX(0);
}
.nav-drawer .nav-container {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
}
.nav-drawer .nav-menu {
  transition: transform var(--go-duration-normal) var(--go-timing-function), visibility var(--go-duration-normal) var(--go-timing-function);
  visibility: visible;
  transform: translateX(0);
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background: var(--drawer-bg-color);
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
@media (prefers-reduced-motion: reduce) {
  .nav-drawer .nav-menu {
    transition-duration: 0s;
  }
}
@media (prefers-reduced-motion: reduce) {
  .nav-drawer .nav-menu {
    transition-duration: 0s;
  }
}
.nav-drawer .nav-menu .nav-drawer-header .header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--nav-header-padding);
}
.nav-drawer .nav-menu .nav-drawer-header .header-row .back-btn {
  margin-right: auto;
}
.nav-drawer .nav-menu .nav-drawer-header .header-row .close-btn {
  margin-left: auto;
  flex: 0 0 auto;
}
.nav-drawer .nav-menu .nav-drawer-header .header-row .title {
  font-weight: bold;
  font-size: var(--go-size-0);
  flex: 1;
}
.nav-drawer .nav-menu.is-sub-nav .nav-drawer-header .title {
  margin-left: 1rem;
}
.nav-drawer .nav-menu nav {
  border-top: 0.125rem solid var(--nav-header-border-color);
  height: 100%;
  padding: 1rem 0;
  flex: 1;
  overflow: auto;
}
.nav-drawer .nav-menu .nav-menu {
  box-shadow: var(--shadow-4);
  visibility: hidden;
  transform: translateX(100%);
}
.nav-drawer ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.nav-drawer .nav-item-inner {
  background: none;
  border: none;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--nav-item-padding);
  color: var(--nav-item-text-color);
  text-decoration: none;
  background: var(--nav-item-bg-color);
  border-left: var(--nav-item-current-bar-width) solid transparent;
}
.nav-drawer .nav-item-inner:hover, .nav-drawer .nav-item-inner:focus {
  background: var(--nav-item-hover-bg-color);
}
.nav-drawer .nav-item-label {
  display: flex;
  align-items: center;
  gap: var(--nav-item-icon-gap);
}
.nav-drawer .children-indicator {
  width: 1.5em;
  height: 1.5em;
}
.nav-drawer li {
  padding: 0;
  line-height: 1.5;
}
.nav-drawer li.active > .nav-menu {
  visibility: visible;
  transform: translateX(0);
  z-index: 2;
}
.nav-drawer li.current > .nav-item-inner {
  border-left-color: var(--nav-item-current-bar-color);
}
.nav-drawer .parent-link {
  border-bottom: var(--submenu-parent-link-border-bottom);
}
.nav-drawer .parent-link a {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: var(--nav-item-padding);
  color: var(--nav-item-text-color);
  text-decoration: none;
  background: var(--nav-item-bg-color);
  font-weight: bold;
  border-left: var(--nav-item-current-bar-width) solid transparent;
}
.nav-drawer .parent-link a svg {
  transition: transform var(--go-duration-normal) var(--go-timing-function);
  margin-left: 0.5rem;
  width: 1.25em;
  height: 1.25em;
  transform: translateX(0);
}
@media (prefers-reduced-motion: reduce) {
  .nav-drawer .parent-link a svg {
    transition-duration: 0s;
  }
}
.nav-drawer .parent-link a:hover, .nav-drawer .parent-link a:focus {
  background: var(--nav-item-hover-bg-color);
}
.nav-drawer .parent-link a:hover svg, .nav-drawer .parent-link a:focus svg {
  transform: translateX(0.3125rem);
}